import { Delete } from "@mui/icons-material";
import { Button } from "@mui/material";
import useDelete from "../../../hooks/useDelete";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function DeleteMessage({ handleClose, msgId }) {
  const [searchParams] = useSearchParams();
  const convoId = searchParams.get("convo");
  const { t } = useTranslation();

  const del = useDelete(
    msgId,
    "/inbox/message/",
    "messages_for_convo" + convoId,
    "DeleteMessage",
    null
  );
  const handleDelete = async () => {
    const res = await del.deleteFn();
    if (res) {
      handleClose();
    }
  };
  return (
    <>
      <Button color="error" onClick={handleDelete} startIcon={<Delete />}>
        {t("Delete")}
      </Button>
      <del.ConfirmationDialog />
    </>
  );
}
